/*
 * Copyright (c) CIRROM 2025.
 */

import { green, red } from "@mui/material/colors";
import { TrendItem } from "../api/integratedsystems";

export const computeTrend = (
  trend: TrendItem | undefined,
  categoryNumber: number
): number => {
  if (!trend) {
    return 0;
  }

  if (trend.old && categoryNumber) {
    return Math.round(((categoryNumber - trend.old) / trend.old) * 100);
  }
  if (trend.old && !categoryNumber) {
    return -100;
  }
  if (!trend.old && !categoryNumber) {
    return 0;
  }
  if (!trend.old && categoryNumber) {
    return 100;
  }

  return 0;
};

export const getPercentageText = (trendValue: number): string => {
  if (trendValue === 0) return "0%";
  return `${trendValue > 0 ? "+" : ""}${trendValue}%`;
};

export const getPercentageColor = (trendValue: number): string => {
  return trendValue > 0 ? red[500] : green[500];
};
